<template>
  <v-overlay :value="overlay" class="text-center" :opacity="0.80">
    <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
    <p class="mt-3 font-weight-bold" color="primary">{{ overlayMessage }}</p>
  </v-overlay>
</template>

<script>
export default {
  name: "Overlay",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    overlayMessage: {
      type: String,
    },
  },
  data: () => ({
    overlay: false,
  }),
  // watch: {
  //   overlay(val) {
  //     val &&
  //       setTimeout(() => {
  //         this.overlay = false;
  //       }, 3000);
  //   },
  // },
};
</script>

<style lang="scss" scoped></style>
